import { useEffect, useRef } from 'react';
import { FixedSizeList } from 'react-window';
import { TitleRowTabOperations } from 'components/TitleRowTabOperations';
import { useGetTabOperationsQuery } from 'redux/Api/operationsApi/operationsApi';
import { DealsOperationsItem } from 'ui/DealsOperationsItem';
import { useDispatch } from 'react-redux';
import { setCountTab } from 'redux/operationInfo/slice';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { Link } from 'react-router-dom';
import { Nothing } from 'components/Nothing';
import styles from './Deals.module.scss';

interface DealsPropsTypes {
  title: string;
}

export const Deals = ({ title }: DealsPropsTypes) => {
  const refList = useRef<FixedSizeList>(null);
  const pageHeight = document.documentElement.scrollHeight;
  const { data, isLoading } = useGetTabOperationsQuery({ title });
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) dispatch(setCountTab({ countTab: data.count, nameTab: 'Сделки' }));
  }, [data]);

  const dataDeals = [
    'id',
    'Сумма',
    'Заказчик',
    'Получатель',
    'Ответ комплайнс',
    'Статус',
  ];

  const Row = ({ index, style = {} }: { index: number; style: React.CSSProperties }) => {
    const item = data?.items[index];

    if (!item || !('order' in item)) return null;
    return (
      <div style={style}>
        <Link to={`/operations/deals/${item.id}`}>
          <DealsOperationsItem deal={item} />
        </Link>
      </div>
    );
  };

  return (
    <div className={styles.root}>
      {isLoading ? (
        <LoadingSkeleton widthTab />
      ) : (
        <>
          <TitleRowTabOperations data={dataDeals} title={title} />
          {data ? (
            <FixedSizeList
              className={styles.window}
              ref={refList}
              height={
                data?.items.length < 10 ? 83 * data?.items.length : pageHeight - 300
              }
              width='100%'
              itemCount={data?.items.length ? data?.items.length : 0}
              itemSize={81}>
              {Row}
            </FixedSizeList>
          ) : (
            <Nothing style={{ height: '660px' }} title='Ничего не найдено' />
          )}
        </>
      )}
    </div>
  );
};
